// @ts-nocheck
import React from 'react';
import { withTranslation } from 'react-i18next';

import styles from './alertBanner.module.scss';
import { T } from '@/v2/helpers/i18n';
import { getRedemptionReasonByCode } from '@/v2/wallet/manage/redemption/redemptionDisabledReasons.ts';
import Banner from '@/v2/partials/banner/banner.tsx';
import { RedemptionAvailabilityModel } from '@/v2/models/multiEventEnvelopeModel.ts';

type Props = {
  redemptionAvailability: RedemptionAvailabilityModel;
  onClose: Function;
} & T;

const AlertBanner = (props: Props) => {
  const { t, redemptionAvailability, onClose } = props;

  if (!redemptionAvailability?.redemptionDisabled) {
    return null;
  }
  return (
    <div className={styles.alertBanner}>
      <Banner
        config={{
          heading: t(getRedemptionReasonByCode(redemptionAvailability.reason)),
          variant: 'info',
          onRequestClose: onClose,
        }}
      />
    </div>
  );
};

export default withTranslation('translation')(AlertBanner);
